const ThemeProvider = {
    /* -- brand colours --*/
    black: "#1b1e1c",
    white: "#ffffff",
    red: "#D22630",
    gray: "#A7A8A9",
    gold: "#856404",
    lightGold: "#85640426",
    lime: "#7ED321",
    yellow: "#F8FDF4",
    lightGray: "#f3f3f3",
    lightGray1: "#E6E6E6",
    lightGray2: "#757575",
    lightGray3: "#FEFEFE",
    lightGray4: "#686868",
	lightGray5: "#A5A6A8",
    borderGrey: "#D8D8D8",
    darkGrey: "#3C3D3F",
    paleGreen: "#F6FDF1",
    lightGreen: "#008755",
    lightGreen2: "#00A76A26",
    coreGreen: "#94eb5a",
    green: "#00A76A",
    darkGreen: "#3d4543",
    lighterGreen: "#BFE9DA",
    lightBlue: "#e6edf5",
    darkBlue: "#3c3d3f",
    lightYellow: "#fff9e6",
    teal: "#003D4C",
    lightTeal: "#08586C",
	blue: "#217BBE",
    lightBlue2: "#217BBE26",
	lightBlue2: "#DEEBF5",
	red2: "#D53841",
    lightOrange: "#FF9C0026",
    orange: "#FF9C00",
    lightRed: "#D2263026",

    /* --borders --*/
    grayBorder: "2px solid #ccc",
	grayBorder2: "1px solid #CFD0CF",
    lightGrayBorder: "1px solid #E6E6E6 ",
    lightGrayBorderDashed: "1px dashed #d0d0ce",
    greenBorder: "1px solid #008755",
    greenBorderThick: "2px solid #008755",
    redBorder: "1px solid #D22630",
    redBorderThick: "2px solid #D22630",
    darkBlueBorder: "1px solid #003D4C",
    lightTielBorder: "1px solid #08586C",
    lightGreenBorder: "2px solid #94EB54",
    yellowBorder: "2px solid #856404",
    blueBorder: "2px solid #217BBE",

    // breakpoints
    smallMobile: "360px",
    smallTablet: "620px",
    tablet: "768px",
	desktopSmall: "940px",
    desktop: "1200px",

    // font bold
    fontBold: `"AnPostSansBold", sans-serif`,
    plus:
        "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%3E%3Cpath%20d%3D%22M9.9%201.414v16.97M18.385%209.9H1.415%22%20stroke%3D%22%2300a76a%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E",
    minus:
        "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2215%22%20height%3D%223%22%3E%3Cpath%20d%3D%22M13.58%201.727H1.875%22%20stroke%3D%22%2300a76a%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E"
};

export default ThemeProvider;
